"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARDS_BI_ORIGIN = void 0;
var VIDEO_CARDS_BI_ORIGIN;
(function (VIDEO_CARDS_BI_ORIGIN) {
    VIDEO_CARDS_BI_ORIGIN["VIDEO"] = "video";
    VIDEO_CARDS_BI_ORIGIN["ALL_CARDS"] = "all_cards";
})(VIDEO_CARDS_BI_ORIGIN = exports.VIDEO_CARDS_BI_ORIGIN || (exports.VIDEO_CARDS_BI_ORIGIN = {}));
//# sourceMappingURL=video-cards-origin.js.map